import { IMAGES } from "@/assets/images";
import Image, { ImageProps } from "next/image";
import React from "react";

type CustomImageProps = ImageProps;

const CustomImage = (props: CustomImageProps) => {
  const { src: imageSrc, alt } = props;
  const [error, setError] = React.useState<boolean>(false);
  return error ? (
    <Image
      src={IMAGES.PlaceholderImage}
      className={props?.className}
      alt={alt}
      style={{
        objectFit: "contain",
        backgroundColor: "#BCBCBC",
        ...props.style,
      }}
    />
  ) : (
    <Image
      {...props}
      alt={alt}
      onError={() => {
        console.error("Image not found");
        setError(true);
      }}
      src={imageSrc}
    />
  );
};

export default CustomImage;
